import styled from 'styled-components';

export const SideBackgroundImageContainer = styled.div.attrs({})`
  min-height: 100vh;
  height: 100%;
  background: ${(props) => props.theme.palette.gradient.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 767px) {
    position: relative;
    min-height: initial;
    width: 100%;
  }
`;

export const FormContent = styled.div.attrs({})`
  min-height: 100vh;
  display: flex;
  align-items: ${(p) => (p.center ? 'center' : '')};
  justify-content: center;
  position: relative;
  padding: 0 40px;
  background: ${(props) => props.theme.palette.lightgrey.main};
`;

export const Content = styled.div.attrs({})`
  overflow: hidden;
  background: ${(props) => props.theme.palette.colors.background};
  min-width: 100%;
`;
